// extracted by mini-css-extract-plugin
export default {"selection-container":"SupportAuthorizationApprovedLevelTwoModal_selection-container__1Dg3Q"};